import { Container, Stack, Theme, useMediaQuery } from "@mui/material";
import { useEffect } from "react";
import Footer from "../Components/Footer";
import PageSectionBG from "../Components/PageSectionBG";
import { PageShell } from "../Components/PageShell";

const CookiePolicy = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://app.termly.io/embed-policy.min.js";
    script.async = true;
    document.body.appendChild(script);

    const termlyContent = document.getElementById("termly-content");
    if (termlyContent) {
      termlyContent.setAttribute("name", "termly-embed");
    }

    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 1);
  }, []);

  return (
    <PageShell>
      <PageSectionBG
        style={{ position: "relative" }}
        id="cookie-policy-page"
        bgcolor="primary.dark"
        paddingBottom={20}
        paddingTop={
          useMediaQuery((theme: Theme) => theme.breakpoints.up("md")) ? 16 : 8
        }
      >
        <Container maxWidth="lg">
          <Stack
            justifyContent={"start"}
            direction={"column"}
            alignItems={"start"}
            width={"100%"}
            gap={3}
          >
            <div
              data-type="iframe"
              id="termly-content"
              style={{ width: "100%", minHeight: "calc(100vh - 8rem)" }}
              data-id="f3252e57-799f-44a8-85eb-0dcbba81c06c"
            ></div>
          </Stack>
        </Container>
      </PageSectionBG>

      <Footer />
    </PageShell>
  );
};

export default CookiePolicy;
